// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O4gt","col":"styles_col__2B4Nf"};